<div>
    <mat-form-field class="!hidden" appearance="outline" [formGroup]="service.group" [fuiTooltip]="tooltip | async">
        <input
            matInput
            [formControl]="service?.group?.get(service?.field?.name)"
            readonly
            [disabled]="service.field.disabled"
            (click)="editDataInput()"
        />
    </mat-form-field>

    <mat-form-field class="form-full-width" appearance="outline">
        <i
            matPrefix
            *ngIf="service.field.leadingIcon"
            [ngClass]="'mdi mdi-' + service.field.leadingIcon"
            class="input_leading-icon"
        ></i>
        <mat-label>{{ service.field.label }}</mat-label>
        <mat-progress-spinner
            *ngIf="service.isShowSpinner | async"
            matSuffix
            color="primary"
            mode="indeterminate"
            diameter="18"
        >
        </mat-progress-spinner>
        <input
            matInput
            readonly
            [matTooltip]="formControl.value"
            (click)="!service.field.disabled ? editDataInput() : null"
            [disabled]="service.field.disabled"
            [formControl]="formControl"
        />

        <mat-hint *ngIf="service.field.hint" [innerHtml]="service.field.hint"></mat-hint>

        <fui-button
            *ngIf="!service.field.disabled && this.formControl.value !== '' && !(service.isShowSpinner | async)"
            (clickEvent)="
                service.group.get(service.field.name).setValue(null);
                service.group.get(service.field.name).markAsDirty()
            "
            tabindex="-1"
            matSuffix
            [icon]="'close'"
            [title]="appService.language_dictionary.system_clear"
            [type]="'button-icon'"
            [borderRadius]="'circle'"
            [color]="'neutral'"
            [height]="'mini'"
            [iconSize]="16"
        >
        </fui-button>
        <fui-button
            matSuffix
            (clickEvent)="editDataInput()"
            *ngIf="!(service.isShowSpinner | async)"
            [ngClass]="'input_trailing-button !ml-0'"
            [icon]="'pencil-outline'"
            iconSize="20"
            [title]="appService.language_dictionary.system_edit"
            [type]="'button-icon'"
            [borderRadius]="'circle'"
            [color]="'neutral'"
            [height]="'mini'"
            [disabled]="service.field.disabled"
        >
        </fui-button>

        <ng-container *ngFor="let validation of service.field.validations" ngProjectAs="mat-error">
            <mat-error
                *ngIf="formControl?.hasError(validation.name)"
                [innerHTML]="validation.name === 'serverError' ? formControl.errors?.serverError : validation.message"
            >
            </mat-error>
        </ng-container>
    </mat-form-field>
</div>
